var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link",class:{ 'active show': _vm.customizer == 'layouts' },attrs:{"id":"c-pills-home-tab","href":"javascript:void(0)"},on:{"click":function($event){return _vm.openCustomizerSetting('layouts')}}},[_c('div',{staticClass:"settings"},[_c('feather',{attrs:{"type":"grid","size":"20"}})],1),_c('span',[_vm._v("Quick option")])])
}
var staticRenderFns = []

export { render, staticRenderFns }